import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    logToAnalyticsCancelBetClick,
    findAnalytics,
} from '../../../App/analyticsTracking';

const analytics = findAnalytics();
const selectionRemovedEvent = new CustomEvent('BETSLIP.SELECTION_REMOVED');

export const MinimizeButton = (props) => {
    const {
        bookmakerName,
        betslipID,
        selectedBets,
        isDrawerMinimized,
        isQuickslipMode,
        resetQuickslip,
        clearPlacedBetDetails,
        isBetPlacedSuccessfully,
    } = props
    let text = isDrawerMinimized && !isBetPlacedSuccessfully ? 'Open' : 'Close'
    text = isQuickslipMode && !isBetPlacedSuccessfully ? 'Cancel' : text

    const onMinimize = () => {
        if (isQuickslipMode) {
            // Reset the drawer state
            resetQuickslip();
            if (analytics) {
                const selectedBet = selectedBets[0];
                logToAnalyticsCancelBetClick(bookmakerName, betslipID, selectedBet, analytics);
            }
            document.dispatchEvent(selectionRemovedEvent);
        }

        // Reset the drawer & also remove a placed bet if appropriate
        if (isBetPlacedSuccessfully) {
            resetQuickslip()
            clearPlacedBetDetails()
            document.dispatchEvent(selectionRemovedEvent);
        }
    }

    return (
        <div
            role="button"
            tabIndex={0}
            className="bs-drawer__minimizeButton"
        >
            <button
                className="bs-drawer__minimizeButton__button"
                onClick={onMinimize}
            >
                {text}
            </button>
        </div>
    )
};

const betProps = PropTypes.shape({
    price: PropTypes.string,
    outcomersId: PropTypes.string,
    eventId: PropTypes.string,
    meetingId: PropTypes.string,
    raceId: PropTypes.string,
    raceDate: PropTypes.string,
    horseName: PropTypes.string,
    courseName: PropTypes.string,
    raceTime: PropTypes.string,
    eachWayFraction: PropTypes.string,
    eachWayPlaces: PropTypes.string,
    isBog: PropTypes.string,
});

MinimizeButton.propTypes = {
    isDrawerMinimized: PropTypes.bool.isRequired,
    bookmakerName: PropTypes.string,
    betslipID: PropTypes.string,
    isQuickslipMode: PropTypes.bool.isRequired,
    resetQuickslip: PropTypes.func.isRequired,
    clearPlacedBetDetails: PropTypes.func.isRequired,
    isBetPlacedSuccessfully: PropTypes.bool.isRequired,
    selectedBets: PropTypes.arrayOf(betProps),
};

MinimizeButton.defaultProps = {
    selectedBets: [],
    bookmakerName: null,
    betslipID: null,
}

const mapStateToProps = state => ({
    isDrawerMinimized: state.drawerInfo.isDrawerMinimized,
})

export default connect(mapStateToProps, null)(MinimizeButton);



// WEBPACK FOOTER //
// /src/js/drawer/components/MinimizeButton/MinimizeButton.jsx